'use strict';

var Backbone = require('backbone'),
  config = require('../../js/config'),

  GenericSearchModel = Backbone.Model.extend({

    idAttribute: 'uniqueId',

    initialize: function(attrs, options) {
      this.options = options;
      if (options) {
        this.set('uniqueId', this.get(options.collection.options.idAttribute));
      }

      // Only products - which have no pricing data yet
      if (this.get('searchResultType') === config.search.resultTypeProduct && !this.get('pricingDataPopulated')) {
        this.set('primaryBuyingOptionType', 'Loading');
      }
    }

  });

module.exports = GenericSearchModel;



// WEBPACK FOOTER //
// ./assets/components/Search/genericSearchModel.js